import React from 'react';
import { useDashboard } from '../../contexts/DashboardContext';

const DeleteBusinessModal = () => {
  const {
    API,
    appointments,
    axios,
    businessToDelete,
    clients,
    deletingBusiness,
    packages,
    products,
    setAdminData,
    setBusinessToDelete,
    setDeletingBusiness,
    setShowDeleteBusinessModal,
    showDeleteBusinessModal,
    showToast,
    user,
  } = useDashboard();

  return (
    <>
        {/* Delete Business Confirmation Modal */}
        {showDeleteBusinessModal && businessToDelete && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => !deletingBusiness && setShowDeleteBusinessModal(false)}>
            <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6" onClick={e => e.stopPropagation()}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Delete Business</h3>
                  <p className="text-sm text-gray-500">This action cannot be undone</p>
                </div>
              </div>
              
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-red-800 font-medium mb-2">
                  You are about to delete "{businessToDelete.name}"
                </p>
                <p className="text-sm text-red-700">
                  All data connected to this business will be permanently deleted, including:
                </p>
                <ul className="text-sm text-red-700 mt-2 list-disc list-inside space-y-1">
                  <li>All user accounts ({businessToDelete.user_count} users)</li>
                  <li>All appointments ({businessToDelete.appointment_count} appointments)</li>
                  <li>All clients and their data</li>
                  <li>All listings, media, and files</li>
                  <li>All products, packages, and settings</li>
                </ul>
              </div>
              
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowDeleteBusinessModal(false);
                    setBusinessToDelete(null);
                  }}
                  disabled={deletingBusiness}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
                  data-testid="cancel-delete-business-btn"
                >
                  Cancel
                </button>
                <button
                  onClick={async () => {
                    setDeletingBusiness(true);
                    try {
                      await axios.delete(`${API}/admin/business/${businessToDelete.id}`);
                      showToast(`Business "${businessToDelete.name}" deleted successfully`, 'success');
                      // Remove from local state
                      setAdminData(prev => ({
                        ...prev,
                        businesses: prev.businesses.filter(b => b.id !== businessToDelete.id),
                        users: prev.users.filter(u => u.business_id !== businessToDelete.id)
                      }));
                      setShowDeleteBusinessModal(false);
                      setBusinessToDelete(null);
                    } catch (err) {
                      console.error('Delete business error:', err);
                      showToast('Failed to delete business: ' + (err.response?.data?.detail || err.message), 'error');
                    } finally {
                      setDeletingBusiness(false);
                    }
                  }}
                  disabled={deletingBusiness}
                  className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                  data-testid="confirm-delete-business-btn"
                >
                  {deletingBusiness ? (
                    <>
                      <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Deleting...
                    </>
                  ) : (
                    'Confirm Delete'
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default DeleteBusinessModal;
